import { useNavigate } from 'react-router-dom'

import dayjs from 'dayjs';
import 'dayjs/locale/fr';
import 'dayjs/plugin/utc'

import { iconColors } from "../helpers/scripts";

import { Box, Card, CardContent, Typography, Divider } from "@mui/material";
import LocalPostOfficeOutlinedIcon from '@mui/icons-material/LocalPostOfficeOutlined';

const ModuleShipmentCard = ({ stepID, shipements, transporst, filterData }) => {

    let navigate = useNavigate()


    const dark = (i) => {
        let color = '#253a4d'
        let bgColor = '#283747'
        bgColor = ''

        if (i === 'FR') {
            color = '#fff'
            bgColor = '#3e6287'
        }
        return { 'color': color, 'bgColor': bgColor }
    }


    const iconStatus = (shipement, type) => {
        let color = iconColors.gray
        const order = shipement.order_data && shipement.order_data[0]
        if (!order) {
            return color
        }
        const emailConfigShiping = order.source.emailConfigShiping
        const emailConfigOrder = order.source.emailConfigOrder

        const shipementNotif = shipement.shipment_notifications.length
        const ordertNotif = shipement.order_notifications.length


        if (type === 'order' && emailConfigOrder) {
            color = iconColors.yellow
            if (ordertNotif) {
                color = iconColors.green
            }
        }

        if (type === 'shipement' && emailConfigShiping) {
            color = iconColors.yellow
            if (shipementNotif) {
                color = iconColors.green
            }
        }
        return color

    }






    return (
        <>

            {/* {shipements ? shipements.filter(step => step['step_id'] === stepID).map(shipement => */}
            {shipements ? shipements.filter(step => step['step_id'] === stepID).filter(search => filterData.includes(search.id)).map(shipement => {
                const order = shipement.order_data && shipement.order_data[0]
                if (!order) {
                    return (
                        <Card key={shipement.id} variant="outlined" sx={{ my: 1, minWidth: '240px', maxWidth: '320px' }}>
                            <CardContent>
                                <Typography variant="body2">Заказ для этой отправки не найден</Typography>
                            </CardContent>
                        </Card>
                    )
                }

                return (
                <Card key={shipement.id} variant="outlined"
                    onClick={() => { navigate(`${shipement.id}`, { state: shipement }) }}
                    sx={{
                        my: 1,
                        backgroundColor: dark(order.source.division).bgColor,
                        color: dark(order.source.division).color,
                        marginLeft: 'auto',
                        marginRight: 'auto',
                        cursor: 'pointer',
                        minWidth: '240px',
                        maxWidth: '320px',
                        // borderColor: color,
                    }}
                >
                    <CardContent sx={{ fontWeight: 'light', borderRadius: 2, p: 1.2 }}>

                        <Box sx={{ display: 'flex', justifyContent: 'space-between', }}>
                            <Typography variant="body2" sx={{ fontSize: 12 }}>
                                {order.address.country}
                            </Typography>

                            <Typography variant="body2" sx={{ fontSize: 12 }}>
                                {dayjs(shipement.date).format('DD/MM/YYYY HH:MM')}
                            </Typography>
                        </Box>

                        <Box id="name" >
                            <Typography variant="body2" sx={{ fontSize: 12 }}>
                                {order.user.firstName} {order.user.lastName}
                            </Typography>
                        </Box>

                        <Divider sx={{ my: 1 }} />

                        <Box id="transportSupplire" sx={{ display: 'flex', justifyContent: 'space-between', mb: '5px', mt: '10px' }} >
                            <Typography variant="body2" component='div'
                                sx={{ fontSize: 12, display: 'inline', border: '1px solid #0F0F0F', borderRadius: '4px', px: 1 }}>
                                {transporst[shipement.transport]}
                            </Typography>

                            <Typography variant="body2" sx={{ fontSize: 12 }}>
                                {shipement.last_update_date ? dayjs(shipement.last_update_date).format('DD/MM/YYYY HH:MM') : ''}
                            </Typography>
                        </Box>
                        <Box id="transportStatus" sx={{ height: '16px' }}>
                            <Typography variant="body2" noWrap sx={{ fontSize: 12, }}>
                                {shipement.last_update_status ? shipement.last_update_status : shipement.tracking_id ? shipement.tracking_id : ''}
                            </Typography>
                        </Box>


                        <Divider sx={{ my: 1 }} />


                        <Box sx={{ mt: 1, height: '12px' }}>
                            <Typography variant="body2"
                                sx={{
                                    float: 'left',
                                    fontSize: 12,
                                    pt: '5px',
                                    minWidth: '90px'
                                }} >
                                {order.totalQuantity} / {parseFloat(order.totalOrderPrice).toFixed(2)}  €
                            </Typography>

                            <Typography variant="body2" component='span'
                                sx={{
                                    fontSize: 12,
                                    float: 'left',
                                    display: 'inline',
                                    border: '1px solid #0F0F0F',
                                    borderRadius: '4px',
                                    px: '10px',
                                    height: '20px',
                                    minWidth: '50px',
                                    mt: '2px'
                                }}>
                                {order.source.name}
                            </Typography>

                            <div sx={{ float: 'right', }}>

                                <LocalPostOfficeOutlinedIcon sx={{ pt: '2px', float: 'right', color: iconStatus(shipement, 'order') }} />

                                <LocalPostOfficeOutlinedIcon sx={{ pt: '2px', float: 'right', color: iconStatus(shipement, 'shipement') }} />

                            </div>
                        </Box>

                    </CardContent>

                </Card>
                )
            }) : ''}
        </>
    );
};

export default ModuleShipmentCard;